import { render, staticRenderFns } from "./dialog-edit-detail-bzf-unit-price.vue?vue&type=template&id=d440b974&scoped=true&"
import script from "./dialog-edit-detail-bzf-unit-price.vue?vue&type=script&lang=js&"
export * from "./dialog-edit-detail-bzf-unit-price.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d440b974",
  null
  
)

export default component.exports